import Vue from 'vue';
import Vuetify from 'vuetify/lib';
// import 'vuetify/dist/vuetify.min.css';
import nl from 'vuetify/es5/locale/nl';

Vue.use(Vuetify, {
  iconfont: 'fa',
  lang: {
    locales: { nl },
    current: 'nl',
  },
  theme: {
    primary: '#F7A611',
  },
});
